import { useMutation } from '@apollo/client'
import { message } from 'antd'
import {
  DOWNLOAD_IMAGE_WATERMARK,
  DOWNLOAD_VIDEO_WATERMARK,
} from '~/graphqls/gqls'
import {
  downloadImageWatermark,
  downloadImageWatermarkVariables,
  downloadVideoWatermark,
  downloadVideoWatermarkVariables,
  WatermarkVideoDownloadInput,
} from '~/graphqls/types'
import { graphQLErrorMessage } from '~/utils'

/**
 * 添加AI水印的Hook
 */
export const useToWatermarkAi = () => {
  const [downloadImageWatermarkAction] = useMutation<
    downloadImageWatermark,
    downloadImageWatermarkVariables
  >(DOWNLOAD_IMAGE_WATERMARK)
  const [downloadVideoWatermarkAction] = useMutation<
    downloadVideoWatermark,
    downloadVideoWatermarkVariables
  >(DOWNLOAD_VIDEO_WATERMARK)

  /** 添加图片ai水印 */
  const toWatermarkAiImage = async (url: string) => {
    try {
      const res = await downloadImageWatermarkAction({
        variables: {
          param: url,
        },
      })
      return res?.data?.squareModule?.url || ''
    } catch (error) {
      message.destroy()
      message.error(graphQLErrorMessage(error) || '水印添加失败，请重试')
      return ''
    }
  }

  /** 添加视频ai水印 */
  const toWatermarkAiVideo = async (param: WatermarkVideoDownloadInput[]) => {
    try {
      const res = await downloadVideoWatermarkAction({
        variables: {
          param,
        },
      })
      return res?.data?.squareModule?.url || []
    } catch (error) {
      message.destroy()
      message.error(graphQLErrorMessage(error) || '水印添加失败，请重试')
      return []
    }
  }

  return {
    /** 添加图片ai水印 */
    toWatermarkAiImage,
    /** 添加视频ai水印 */
    toWatermarkAiVideo,
  }
}
